import React, { useEffect, useState, useContext } from "react";
import "./AllRequestsPage.scss";
import { Column, Row } from "../../common/columns";
import { GET } from "../../utils/fetchUtil";
import PageWrapper from "../../layout/PageWrapper";
import ResultsTable from "./overview/allRequests/table/ResultsTable";
import NoResultsFound from "../../common/noResultsFound/NoResultsFound";
import FilterForm from "./overview/allRequests/FilterForm";
import Loader from "../../common/loader/Loader";
import { MessageContext } from "../../common/message";
import { useTranslation } from "react-i18next";

function AllRequestsPage() {
  const [numberOfRequests, setNumberOfRequests] = useState();
  const [data, setData] = useState({
    requests: [],
    filterSettings: {
      departments: [],
      requestTypes: [],
      requestStatuses: [],
      solvers: [],
    },
  });

  const [request, setRequest] = useState(undefined);

  const message = useContext(MessageContext);
  const { t } = useTranslation();

  useEffect(() => {
    GET(
      "/requests/submissions?includeFilterSettings=true",
      (data) => {
        setData(data);
        setRequest(data);
        setNumberOfRequests(data.requests.length);
      },
      (error) => {
        message.toggle({
          title: t("requests.reviewDocuments.action.save.error"),
          content: error,
          hideNo: true,
          yesLabel: t("modalMessage.okLabel"),
          onYes: () => {
            message.toggle({});
          },
        });
      }
    );

    return () => setRequest([]);
  }, []);

  if (request) {
    return (
      <>
        <div className="is-pulled-right mr-5 has-text-grey-darker">
          <span className="has-text-purple-dark has-text-weight-bold">Ukupno: </span>
          {numberOfRequests} zahtjeva
        </div>
        <PageWrapper>
          <Row>
            <Column size={2}>
              <FilterForm
                settings={data.filterSettings}
                data={data}
                setData={setData}
                setNumberOfRequests={setNumberOfRequests}
              />
            </Column>
            <Column size={10}>
              {request.requests.length > 0 ? (
                <ResultsTable data={data.requests} />
              ) : (
                <NoResultsFound message={"Nema pronađenih rezultata"} />
              )}
            </Column>
          </Row>
        </PageWrapper>
      </>
    );
  } else {
    return <Loader />;
  }
}

export default AllRequestsPage;
